var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ui-title',{attrs:{"title":_vm.fieldTitle,"fontsize":"smaller-subheading-normal"}}),_c('wsa-text-field',{attrs:{"placeholder":_vm.placeholder},model:{value:(_vm.fieldModel),callback:function ($$v) {_vm.fieldModel=$$v},expression:"fieldModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }